import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import {
  ChartsTooltipContainer,
  useItemTooltip,
} from '@mui/x-charts/ChartsTooltip';
import { formatPrice } from '@/common/utils/money';

function getLabelString(
  label:
    | string
    | ((location: 'arc' | 'legend' | 'tooltip') => string)
    | undefined,
): string {
  if (typeof label === 'string') return label;
  if (typeof label === 'function') return label('arc');
  return '';
}

export function TransactionTypeBreakdownTooltip() {
  const tooltipData = useItemTooltip<'pie'>();
  const { value: tooltipValue } = tooltipData ?? {};
  const { value = 0, label, color } = tooltipValue ?? {};

  return (
    <ChartsTooltipContainer trigger="item">
      <Box
        sx={(t) => ({
          backgroundColor: 'grey.100',
          borderRadius: 1,
          boxShadow: t.shadows[2],
          fontFamily: t.typography.fontFamily,
          padding: 1.5,
          pointerEvents: 'all',
          width: 'fit-content',
        })}
      >
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: color ?? 'grey.500',
              flexShrink: 0,
            }}
          />
          <Typography variant="body2" sx={{ color: 'action.active' }}>
            {getLabelString(label)}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 'fontWeightBold',
              color: 'action.active',
            }}
          >
            {formatPrice(value, true, false)}
          </Typography>
        </Stack>
      </Box>
    </ChartsTooltipContainer>
  );
}
